import { httpService } from './httpService';
import { Client } from '../models/client.model';
import GenericService from './genericService';
import { ListItem } from '../models/ListItem';

class ClientService extends GenericService<Client, ListItem> {
  /**
   * Get clients by RMC ID (direct API call, not cached)
   */
  async getClientsByRmcId(rmcId: number): Promise<Client[]> {
    return await httpService.get<Client[]>(`/api/Client/GetByRMCId/${rmcId}`, undefined, { unwrap: true, normalize: true, toast: false });
  }
  constructor() {
    super('/api/Client')
  }

  async createClient(client: Client): Promise<Client> {
    return await httpService.post<Client>(`/api/Client/Create`, client, undefined, { unwrap: true, normalize: false, toast: true, });
  }

  async getByRMCId(rmcId: number): Promise<Client[]> {
    return await httpService.get<Client[]>(`/api/Client/GetByRMCId/${rmcId}`, undefined, { unwrap: true, normalize: true, toast: false, });
   }

  async getClientsForCurrentUser(): Promise<Client[]> {
    return await httpService.get<Client[]>(`/api/Client/GetClientsForCurrentUser`, undefined, { unwrap: true, normalize: true, toast: false, });
  }

  async saveRmcClientMappings(data:  { rmcId: number, clientIds: number[]}): Promise<boolean> {
  await httpService.post<any>(`/api/Client/SaveRMCClientMappings`, data, undefined, { unwrap: true, normalize: false, toast: true, });
  return true;
}
}

export const clientService = new ClientService();
